import Redirect from '@/views/Redirect';
import { types } from '../store/rootTypes';
import Logout from '../components/Logout';
import store from '../store';
import Login from '../views/Login';
import SetPassword from '../views/SetPassword';

export default [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter(to, from, next) {
      if (!store.getters[types.authentication.getters.isAuthenticated]) {
        next();
      } else {
        next({ name: 'home' });
      }
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
  {
    path: '/setPassword',
    name: 'setPassword',
    component: SetPassword,
  },
  {
    path: '/redirect',
    name: 'Redirect',
    component: Redirect,
  },
];
